module.exports = __webpack_public_path__ + "img/collective-view-more.c096e1d5.png";